import { Component } from '@theme/component';

class DisclosureCustom extends Component {
  requiredRefs = ['disclosureTrigger', 'disclosureContent'];

  #controller = new AbortController();

  connectedCallback() {
    super.connectedCallback();
    const { signal } = this.#controller;
    this.refs.disclosureTrigger.addEventListener('click', this.#handleToggle, { signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller.abort();
  }

  #handleToggle = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const button = this.refs.disclosureTrigger;
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));

    const panel = this.refs.disclosureContent;
    if (!panel) return;

    // Mirror accordion-custom: toggle inert to block interaction when collapsed
    if (expanded) {
      panel.setAttribute('inert', '');
    } else {
      panel.removeAttribute('inert');
    }
  };
}

if (!customElements.get('disclosure-custom')) {
  customElements.define('disclosure-custom', DisclosureCustom);
}